import Cookies from "js-cookie";
import { cookieConstants } from "../_redux/_constants";
//TODO:Implement after login auth implementaion

export const setCsrfToken = (token) => {
    Cookies.set("XSRF-TOKEN", token);
};

export const getCsrfToken = () => {
    return Cookies.get("XSRF-TOKEN");
};

export const isUserLoggin = () => {
    const isLogin = Cookies.get(cookieConstants.IS_LOGGED_IN);
    const username = Cookies.get(cookieConstants.USER_NAME);

    if (typeof isLogin != "undefined" && typeof username != "undefined") {
        return true;
    }

    return false;
};

export const getUserDetails = () => {
    const userDetails = Cookies.get(cookieConstants.USER_DETAILS_COOKIE);
    if (typeof userDetails != "undefined") {
        return JSON.parse(Cookies.get(cookieConstants.USER_DETAILS_COOKIE));
    }

    return {};
};

export const removeUserDetails = () => {
    Cookies.remove(cookieConstants.USER_DETAILS_COOKIE);
};
